module.exports = __webpack_public_path__ + "img/2.2ee9beb7.jpg";